/* ============================================================
   IMENHOF BLOOM — Bezorgweek-kiezer
   - Standaard "Zo snel mogelijk". Onder die optie staat het concrete
     bezorgvenster uit het gedeelde bezorgdatum-systeem (window.ImhLevertijd),
     zelfde bron als het levertijdblok op de productpagina.
   - Het gekozen moment (incl. venster bij "zo snel mogelijk") wordt als
     orderkenmerk "Bezorgweek" opgeslagen en loopt mee naar de bestelling.
   - Optioneel een latere week. Die weken beginnen NA het "zo snel mogelijk"-
     venster, zodat "later" altijd echt later is (geen overlap).
   - Werkt in de cart drawer en op de cartpagina; instanties blijven synced.
     De cartpagina-instantie wordt hier geinjecteerd zodat main-cart.liquid
     onaangeroerd blijft.
   ============================================================ */
(function () {
  'use strict';
  var ASAP_LABEL = 'Zo snel mogelijk';
  var ATTR = 'Bezorgweek';
  var MONTHS = ['januari','februari','maart','april','mei','juni','juli','augustus','september','oktober','november','december'];
  var L = window.ImhLevertijd || null;

  var template = document.querySelector('[data-imh-bezorgweek]');
  if (!template) return;

  /* ---- Cartpagina-instantie injecteren (klonen uit de drawer) ---- */
  if (document.body.classList.contains('template-cart')) {
    var aside = document.querySelector('.cart-aside');
    if (aside && !aside.querySelector('[data-imh-bezorgweek]')) {
      var clone = template.cloneNode(true);
      Array.prototype.forEach.call(clone.querySelectorAll('input[type="radio"]'), function (r) {
        r.name = 'imh-bw-page';
        r.checked = (r.value === 'asap');
      });
      var checkoutBtn = aside.querySelector('[name="checkout"]');
      if (checkoutBtn) aside.insertBefore(clone, checkoutBtn); else aside.appendChild(clone);
    }
  }

  var nodes = Array.prototype.slice.call(document.querySelectorAll('[data-imh-bezorgweek]'));
  if (!nodes.length) return;

  /* ---- ISO-week + helpers ---- */
  function isoWeek(date) {
    var d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    var dayNum = (d.getUTCDay() + 6) % 7;
    d.setUTCDate(d.getUTCDate() - dayNum + 3);
    var firstThu = new Date(Date.UTC(d.getUTCFullYear(), 0, 4));
    var firstDayNum = (firstThu.getUTCDay() + 6) % 7;
    firstThu.setUTCDate(firstThu.getUTCDate() - firstDayNum + 3);
    var week = 1 + Math.round((d - firstThu) / 604800000);
    return { week: week, year: d.getUTCFullYear() };
  }
  function mondayOf(date) {
    var x = new Date(date); var g = x.getDay(); var diff = (g === 0 ? -6 : 1 - g);
    x.setDate(x.getDate() + diff); x.setHours(0, 0, 0, 0); return x;
  }
  function parseISO(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s.trim());
    if (!m) return null;
    return new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
  }
  function parseBlocked(raw) {
    var ranges = [];
    if (!raw) return ranges;
    raw.split(/\r?\n/).forEach(function (line) {
      line = line.trim(); if (!line) return;
      var dates = line.match(/\d{4}-\d{2}-\d{2}/g); if (!dates) return;
      var a = parseISO(dates[0]); var b = dates[1] ? parseISO(dates[1]) : parseISO(dates[0]);
      if (!a || !b) return;
      if (a > b) { var t = a; a = b; b = t; }
      a.setHours(0, 0, 0, 0); b.setHours(23, 59, 59, 0);
      ranges.push([a, b]);
    });
    return ranges;
  }
  function overlapsBlocked(monday, sunday, ranges) {
    for (var i = 0; i < ranges.length; i++) {
      if (monday <= ranges[i][1] && sunday >= ranges[i][0]) return true;
    }
    return false;
  }
  function weekLabel(monday) {
    var sunday = new Date(monday); sunday.setDate(monday.getDate() + 6);
    var iso = isoWeek(monday); var label;
    if (monday.getMonth() === sunday.getMonth()) {
      label = 'Week ' + iso.week + ' (' + monday.getDate() + ' t/m ' + sunday.getDate() + ' ' + MONTHS[sunday.getMonth()] + ')';
    } else {
      label = 'Week ' + iso.week + ' (' + monday.getDate() + ' ' + MONTHS[monday.getMonth()] + ' t/m ' + sunday.getDate() + ' ' + MONTHS[sunday.getMonth()] + ')';
    }
    if (iso.year !== new Date().getFullYear()) label += ' ' + iso.year;
    return label;
  }
  function todayMidnight() { var t = new Date(); t.setHours(0, 0, 0, 0); return t; }

  /* ---- ASAP-venster (weergave + opslagwaarde) uit gedeelde bron ---- */
  var asapInfo = '';
  var asapStore = ASAP_LABEL;
  if (L) {
    var w = L.stdWindow();
    asapInfo = 'In huis tussen ' + L.fmt(w.start) + ' en ' + L.fmt(w.end) + ' \u00b7 Zeeland/Limburg \u00b1 een week later';
    asapStore = ASAP_LABEL + ' (in huis tussen ' + L.fmt(w.start) + ' en ' + L.fmt(w.end) + '; Zeeland/Limburg \u00b1 een week later)';
  }

  /* ---- Latere weken: starten NA het ASAP-venster (geen overlap) ---- */
  function buildWeeks(weeksAhead, ranges) {
    var out = [];
    var startMon;
    if (L) {
      startMon = mondayOf(L.work(L.today(), 8)); // maandag van de week met het ASAP-einde
      startMon.setDate(startMon.getDate() + 7);  // de week daarna
    } else {
      startMon = mondayOf(todayMidnight()); startMon.setDate(startMon.getDate() + 14);
    }
    var d = new Date(startMon); var guard = 0;
    while (out.length < weeksAhead && guard < 100) {
      guard++;
      var monday = new Date(d);
      var sunday = new Date(d); sunday.setDate(monday.getDate() + 6);
      if (!overlapsBlocked(monday, sunday, ranges)) out.push(weekLabel(monday));
      d.setDate(d.getDate() + 7);
    }
    return out;
  }

  /* ---- Cart attribute schrijven ---- */
  function writeAttr(value) {
    current = value;
    var body = { attributes: {} };
    body.attributes[ATTR] = value;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () {});
  }

  /* ---- State ---- */
  var weeks = buildWeeks(
    Math.max(2, parseInt(template.getAttribute('data-weeks-ahead'), 10) || 10),
    parseBlocked(template.getAttribute('data-blocked'))
  );
  var current = (template.getAttribute('data-current') || '').trim();
  var mode = (!current || current.indexOf(ASAP_LABEL) === 0) ? 'asap' : 'later';
  var selectedWeek = (mode === 'later') ? current : (weeks[0] || '');
  if (mode === 'later' && selectedWeek && weeks.indexOf(selectedWeek) === -1) weeks.unshift(selectedWeek);

  function storeValue() { return mode === 'asap' ? asapStore : selectedWeek; }
  function syncAll() { nodes.forEach(function (n) { if (n._apply) n._apply(); }); }

  function initOne(root) {
    var radios = Array.prototype.slice.call(root.querySelectorAll('input[type="radio"]'));
    var weeksWrap = root.querySelector('.imh-bw__weeks');
    var select = root.querySelector('.imh-bw__select');
    var status = root.querySelector('[data-imh-bw-status]');
    var asapEl = root.querySelector('[data-imh-bw-asap]');
    if (asapEl) asapEl.textContent = asapInfo;

    select.innerHTML = '';
    weeks.forEach(function (wk) {
      var o = document.createElement('option');
      o.value = wk; o.textContent = wk;
      select.appendChild(o);
    });

    root._apply = function () {
      var isLater = (mode === 'later');
      radios.forEach(function (r) { r.checked = (r.value === (isLater ? 'later' : 'asap')); });
      weeksWrap.hidden = !isLater;
      if (isLater && selectedWeek) select.value = selectedWeek;
      if (status) status.textContent = isLater ? ('Gekozen: ' + selectedWeek) : 'Gekozen: zo snel mogelijk';
    };

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        if (r.value === 'asap') { mode = 'asap'; }
        else { mode = 'later'; selectedWeek = select.value || weeks[0] || selectedWeek; }
        syncAll(); writeAttr(storeValue());
      });
    });
    select.addEventListener('change', function () {
      mode = 'later'; selectedWeek = select.value;
      syncAll(); writeAttr(storeValue());
    });

    root._apply();
  }

  nodes.forEach(initOne);

  /* ---- "Zo snel mogelijk" + venster vastleggen in de order ---- */
  function ensureDefault() {
    if (mode !== 'asap') return;
    if (current === asapStore) return;
    writeAttr(asapStore);
  }
  if (document.body.classList.contains('template-cart')) ensureDefault();
  var drawer = document.getElementById('CartDrawer');
  if (drawer && 'MutationObserver' in window) {
    new MutationObserver(function () {
      if (drawer.classList.contains('is-open')) ensureDefault();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  /* Lazy-load: als de drawer al open is bij init, meteen de standaard vastleggen. */
  if (drawer && drawer.classList.contains('is-open')) ensureDefault();
})();
